import { defineBlock, smartProps, BlockWrapper } from '@smartfire/js-block-engine';
import style from './block.module.scss';

function Block({ clubId }) {
    const guideUrl =
        clubId !== undefined && clubId !== '0'
            ? `https://gesthand.net/ihand-central/public/structure/guideDuLicence/${clubId}`
            : 'https://gesthand.net/ihand-central/public/structure/guideDuLicence/1';
    return (
        <BlockWrapper.Div className={style.block}>
            <div className={style.content}>
                <h2 className={style.title}>
                    Le guide du <span>licencié</span>
                </h2>
                <p>
                    <span style={{ fontWeight: 800 }}>
                        Le guide du licencié est conçu pour vous accompagner dans vos
                        premiers pas de licenciés au sein d’un club de la FFHandball et de
                        votre fédération.
                    </span>
                    <br />
                    Néophytes ou licenciés confirmés, ce guide est personnalisé à votre
                    club et il est à votre disposition pour vous rendre accessible
                    l’ensemble des informations essentielles afin de mieux connaître votre
                    environnement et vous orienter vers les supports d’informations qui
                    vous accompagneront tout au long de la saison.
                </p>
                <a
                    href={guideUrl}
                    target="_blank"
                    rel="noreferrer"
                    className={style.guideUrl}
                >
                    TÉLÉCHARGEZ LE GUIDE
                </a>
            </div>
            <div className={style.background} />
        </BlockWrapper.Div>
    );
}

export default defineBlock({
    Block,
    smartProps: {
        clubId: smartProps.string.withDefault(undefined),
    },
});
